export default {"src":"/_next/static/media/google-pay-logo.9cc3f132.svg","height":62,"width":115,"blurWidth":0,"blurHeight":0};